/** Os materiais de cada elemento de um modelo aberto, lidos do texto do
 *  IFC uma vez e guardados. Partilhado pelo preenchimento dos cortes no
 *  3D e pelas tramas das Vistas 2D, para os dois decidirem o mesmo.
 *
 *  A chave é o ModeloStep: reabrir o ficheiro dá outro. Os localIds do
 *  Fragments são os #ids do IFC (confirmado no Cha139, 18/10/2026). Um
 *  modelo sem o texto do IFC (aberto de um .frag) não tem materiais. */

import { modeloEmTexto } from '@viewer/dados/modeloEmTexto'
import type { ModeloStep } from '@viewer/lib/step/modeloStep'
import { indiceDeMateriais, materiaisDoElemento, type IndiceDeMateriais } from './estilosDeCorte'

const porModelo = new WeakMap<ModeloStep, { ix: IndiceDeMateriais; porElemento: Map<number, string[]> }>()

export function leitorDeMateriais(modelId: string): (localId: number) => string[] {
  const m = ((): ModeloStep | null => {
    try {
      return modeloEmTexto(modelId)
    } catch {
      return null
    }
  })()
  if (!m) return () => []
  let c = porModelo.get(m)
  if (!c) {
    c = { ix: indiceDeMateriais(m), porElemento: new Map() }
    porModelo.set(m, c)
  }
  const { ix, porElemento } = c
  return (localId) => {
    let l = porElemento.get(localId)
    if (!l) {
      l = materiaisDoElemento(m, ix, localId)
      porElemento.set(localId, l)
    }
    return l
  }
}
